import { useState, useEffect, useRef } from "react";
import { SketchPicker } from "react-color";
import React from "react";
import Draggable from "react-draggable";

export const SlidingTextModal = ({
  id,
  componentInfo,
  slidingTextData,
  deleteData,
  patchSettingsToBackend2,
  componentName
}) => {
  const [settings, setSettings] = useState({});
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [isDraggable, setIsDraggable] = useState(true);
  const [timeouts, setTimeouts] = useState({
    slidingText: null,
    textSize: null,
    animationDuration: null,
    height: null,
    width: null,
    xPosition: null,
    yPosition: null,
    opacity: null,
    zIndex: null
  });
  const nodeRef = useRef(null);

  useEffect(() => {
    if (componentInfo) {
      setSettings({
        backgroundColor: componentInfo.color,
        textColor: componentInfo.textColor,
        opacity: componentInfo.opacity,
        width: componentInfo.width,
        height: componentInfo.height,
        textSize: componentInfo.textSize,
        animationDuration: componentInfo.animationDuration,
        slidingText: componentInfo.slidingText,
        xPosition: componentInfo.xPosition,
        yPosition: componentInfo.yPosition,
        zIndex: componentInfo.zIndex,
        boldText: componentInfo.boldText
      });
    }
  }, [componentInfo]);

  const updateTimeout = (key, value) => {
    setTimeouts((prevTimeouts) => ({
      ...prevTimeouts,
      [key]: value,
    }));
  };

  useEffect(() => {
    return () => {
      Object.values(timeouts).forEach((timeout) => clearTimeout(timeout));
    };
  }, [timeouts]);

  const handleOnBackgroundChange = (color) => {
    const newColor = color.hex;
    setSettings({ ...settings, backgroundColor: newColor });
    patchSettingsToBackend2(
      { color: newColor },
      slidingTextData.SettingsJson,
      id
    );
  };

  const handleOnTextColorChange = (color) => {
    const newColor = color.hex;
    setSettings({ ...settings, textColor: newColor });
    patchSettingsToBackend2(
      { textColor: newColor },
      slidingTextData.SettingsJson,
      id
    );
  };

  const handleSettingChange = (key, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [key]: value,
    }));
    clearTimeout(timeouts[key]);
    updateTimeout(
      key,
      setTimeout(() => {
        patchSettingsToBackend2(
          { [key]: value },
          slidingTextData.SettingsJson,
          id
        );
      }, 500)
    );
  };

  const handleInputChange = (key, value, maxLimit) => {
    let parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      parsedValue = 2; 
    } else if (parsedValue > maxLimit) {
      parsedValue = maxLimit; 
    }
    handleSettingChange(key, parsedValue);
  };

  const handleTextChange = () => {
    const newTextBold = !settings.boldText;
    setSettings({ ...settings, boldText: newTextBold });
    patchSettingsToBackend2(
      {
        boldText: newTextBold,
      },
      slidingTextData.SettingsJson,
      id
    );
  };

  return (
    <Draggable nodeRef={nodeRef} disabled={!isDraggable}>
      <div
        className="modal"
        id={`slidingTextModal${id}`}
        tabIndex="-1"
        aria-labelledby="slidingTextModal"
        aria-hidden="true"
        data-bs-backdrop="static"
        ref={nodeRef}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h4 className="modal-title fs-5" id="slidingTextModal">
               Properties for  {componentName}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body" onMouseEnter={() => setIsDraggable(false)} onMouseLeave={() => setIsDraggable(true)}>
              <>
                <ol className="list-group list-group-flush text-start">
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className=" me-auto">Opacity</div>
                    <span className="me-2">{settings.opacity}%</span>
                    <span className="">
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="100"
                        step="25"
                        id="customRangeSliding"
                        value={settings.opacity || 0}
                        onChange={(e) =>
                          handleSettingChange(
                            "opacity",
                            parseInt(e.target.value)
                          )
                        }
                      />
                    </span>
                  </li>
            
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="row w-100">
                      <div className="col input-group">
                        <span
                          className="input-group-text border-end-0"
                          id="slidingwidth"
                        >
                          width
                        </span>
                        <input
                          name="slidingwidth"
                          type="number"
                          min={2}
                          max={24 - settings.xPosition || 0}
                          className="form-control"
                          aria-label="width"
                          aria-describedby="width"
                          onChange={(e) => handleInputChange("width", e.target.value, 24 - settings.xPosition)}
                          value={settings.width || ""}
                        />
                      </div>
                      <div className="col input-group">
                        <span className="input-group-text" id="height">
                          height
                        </span>
                        <input
                          name="slidingheight"
                          min={2}
                          max={24 - settings.yPosition || 0}
                          type="number"
                          className="form-control"
                          aria-label="Username"
                          aria-describedby="height"
                          onChange={(e) => handleInputChange("height", e.target.value, 24 - settings.yPosition)}
                          value={settings.height || ""}
                        />
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="row w-100">
                      <div className="col input-group">
                        <span className="input-group-text" id="X">
                          X
                        </span>
                        <input
                          name="slidingX"
                          type="number"
                          className="form-control"
                          aria-label="slidingX"
                          min={0}
                          max={24 - settings.width || 0}
                          aria-describedby="slidingX"
                          onChange={(e) => handleInputChange("xPosition", e.target.value, 24 - settings.width)}
                          value={settings.xPosition || 0}
                        />
                      </div>
                      <div className="col input-group">
                        <span className="input-group-text border-end-0" id="Y">
                          Y
                        </span>
                        <input
                          name="slidingY"
                          type="number"
                          min={0}
                          max={24 - settings.height || 0}
                          className="form-control"
                          aria-label="slidingY"
                          aria-describedby="slidingY"
                          onChange={(e) => handleInputChange("yPosition", e.target.value, 24 - settings.height)}
                          value={settings.yPosition || 0}
                        />
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">zIndex</div>
                    <input
                      name="textsizeSliding"
                      type="number"
                      min="1"
                      className="form-control w-25 me-4"
                      value={settings.zIndex || 0}
                      onChange={(e) =>
                        handleSettingChange(
                          "zIndex",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">Text size</div>
                    <input
                      name="textsizeSliding"
                      type="number"
                      min="1"
                      className="form-control w-25 me-4"
                      value={settings.textSize || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "textSize",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">Animation duration</div>
                    <input
                      name="animationSliding"
                      type="number"
                      min="1"
                      className="form-control w-25 me-4"
                      value={settings.animationDuration || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "animationDuration",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label"
                        htmlFor={`slidingTextBold ${id}`}
                      >
                        {settings.boldText
                          ? "Bold text"
                          : "Normal text"}
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`slidingTextBold ${id}`}
                        checked={settings.boldText || false}
                        onChange={handleTextChange}
                      />
                    </div>
                  </li>
                </ol>
              </>
              <div
                className="accordion accordion-flush"
                id="accordionSlidingText"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOneSlidingText"
                      aria-expanded="true"
                      aria-controls="collapseOneSlidingText"
                    >
                      Background Color
                    </button>
                  </h2>
                  <div
                    id="collapseOneSlidingText"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionSlidingText"
                  >
                    <div className="accordion-body">
                      <SketchPicker
                        color={settings.backgroundColor}
                        onChangeComplete={handleOnBackgroundChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFourSlidingText"
                      aria-expanded="true"
                      aria-controls="collapseFourSlidingText"
                    >
                      Text Color
                    </button>
                  </h2>
                  <div
                    id="collapseFourSlidingText"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionSlidingText"
                  >
                    <div className="accordion-body">
                      <SketchPicker
                        color={settings.textColor}
                        onChangeComplete={(color) =>
                          handleOnTextColorChange(color)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-floating ms-4 me-4">
                <textarea
                  className="form-control"
                  placeholder="Leave a comment here"
                  id={`floatingTextareaSliding ${id}`}
                  style={{ height: "100px" }}
                  value={settings.slidingText}
                  onChange={(e) =>
                    handleSettingChange("slidingText", e.target.value)
                  }
                ></textarea>
                <label htmlFor={`floatingTextareaSliding ${id}`}>
                  Add a text{" "}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              {deleteConfirmation ? (
                <>
                  <div>Are you sure ?</div>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm rounded-0 "
                    onClick={deleteData}
                    data-bs-dismiss="modal"
                  >
                    YES
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm rounded-0"
                    onClick={() => setDeleteConfirmation(false)}
                  >
                    NO
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm rounded-0 "
                    onClick={() => setDeleteConfirmation(true)}
                  >
                    {" "}
                    REMOVE COMPONENT{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm rounded-0"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Draggable>
  );
};
